export function extractFilename(href: string, children: any): string {
  const text = Array.isArray(children) ? children.join("") : String(children);
  const match = text.match(/([^\s/\\]+\.\w+)/);
  return match ? match[1] : "file.txt";
}
